import styled from "@emotion/styled/macro"
import { theme } from "../Theme"

import { Accordion, AccordionItemButton } from "react-accessible-accordion"

const StyledAccordion = styled(Accordion)`
  border: none;
  border-radius: 0;

  .accordion__heading {
    .accordion__button {
      background: transparent;
      padding: 0;

      &:before {
        display: none;
      }
    }
  }

  .accordion__panel {
    padding: 0 0 29px;
  }

  .accordion__item + .accordion__item {
    border-top: none;
  }
`

const StyledAccordionItemButton = styled(AccordionItemButton)`
  position: relative;
  outline: none;
`

const Arrow = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
  font-family: ${theme.fonts.main};
  font-size: ${props => (props.open ? "50px" : "30px")};
  font-weight: ${props => (props.open ? 300 : 600)};
  line-height: 61px;
  letter-spacing: 0px;
  text-align: left;
  color: #a8a8a8;
`

export { StyledAccordion, StyledAccordionItemButton, Arrow }
